import React, { createContext, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SelectType } from '../components/DropdownSelect';
import LoginController from '../controller/LoginController';
import { StoreType } from '../controller/StoreController';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { APP_TYPE } from '../utils/DataType';
import { getActionData, isInAppWebView } from '../utils/util';

export const AuthContext = createContext<any>(null);

type Props = {
  children: React.ReactNode;
};

export const AuthProvider = React.forwardRef((props: Props, oRef: any) => {
  const { children } = props;

  const [token, setToken] = React.useState('');
  const [refreshToken, setRefreshToken] = React.useState('');
  const [userInfo, setUserInfo] = React.useState<any>();
  const [currentStore, setCurrentStore] = useState<SelectType>();
  const [isLoggedIn, setIsLoggedIn] = React.useState<any>('');

  const handleLogin = async (
    sId: string,
    sPassword: string,
    bSaveId: boolean,
    bSavePw: boolean,
  ) => {
    let localUuid = await AsyncLocalStorage.getItem('uuid');

    if (!localUuid) {
      localUuid = JSON.stringify(uuidv4());
      AsyncLocalStorage.setItem('uuid', localUuid);
    }

    let oRes = await LoginController.signIn({
      id: sId.toString(),
      password: sPassword.toString(),
      device_uuid: localUuid,
      app_type: APP_TYPE.KNOCKHOTEL,
      version: null,
    });
    console.log('signIn', oRes.data);
    if (oRes.data && !oRes.data.ok) {
      return oRes.data;
    }

    if (oRes.data && oRes.data.ok) {
      let oUserData = oRes.data.data;
      const currentStore: StoreType = oUserData.store_list.find(
        (item: StoreType) => item.store_type === 4,
      );
      console.log('loginUserData', oUserData);

      if (currentStore) {
        setToken(oUserData.token);
        setRefreshToken(oUserData.refresh_token);
        setUserInfo(oUserData);
        setCurrentStore({
          key: 0,
          value: currentStore.store_id,
          name: currentStore.store_name,
          label: currentStore.store_name,
        });
        AsyncLocalStorage.setItem(
          'hotel-currentStore',
          JSON.stringify({
            key: 0,
            value: currentStore.store_id,
            name: currentStore.store_name,
            label: currentStore.store_name,
          }),
        );

        AsyncLocalStorage.setItem('hotel-userToken', oUserData.token);
        AsyncLocalStorage.setItem('hotel-userRefreshToken', oUserData.refresh_token);
        AsyncLocalStorage.setItem('hotel-userData', JSON.stringify(oUserData));

        if (bSaveId === true) {
          AsyncLocalStorage.setItem('hotel-savedId', sId);
          AsyncLocalStorage.setItem('hotel-savedIdCheck', bSaveId.toString());
        }
        if (bSavePw === true) {
          AsyncLocalStorage.setItem('hotel-savedPassword', sPassword.toString());
          AsyncLocalStorage.setItem('hotel-savedPasswordCheck', bSavePw.toString());
        }

        // webView 로그인 데이터 전송
        if (isInAppWebView()) {
          window.ReactNativeWebView?.postMessage(getActionData('send_auth', { auth: oUserData }));
        }
      } else {
        console.log('login error');
      }
    }
  };

  const handleLogout = async () => {
    const firebase_token = await AsyncLocalStorage.getItem('hotel-firebaseToken');
    if (firebase_token) {
      await LoginController.logout({
        firebase_token,
      });
      AsyncLocalStorage.removeItem('hotel-firebaseToken');
    }
    console.log('logout');
    setUserInfo(null);
    AsyncLocalStorage.setItem('hotel-userData', '');
    AsyncLocalStorage.setItem('hotel-userToken', '');
    AsyncLocalStorage.setItem('hotel-userRefreshToken', '');
    AsyncLocalStorage.setItem('hotel-currentStore', '');
    window.location.replace(`${process.env.REACT_APP_BASE_URL}`);
  };

  const onChangeCurrentStore = async () => {
    let oCurrentStore: any = await AsyncLocalStorage.getItem('hotel-currentStore');
    setCurrentStore(oCurrentStore || AsyncLocalStorage.getItem('currentStore'));
  };

  const value = {
    token,
    refreshToken,
    userInfo,
    currentStore,
    handleLogin: handleLogin,
    handleLogout: handleLogout,
    onChangeCurrentStore: onChangeCurrentStore,
  };

  const init = async () => {
    let sToken: string = await AsyncLocalStorage.getItem('hotel-userToken');
    let sRefreshToken: string = await AsyncLocalStorage.getItem('hotel-userRefreshToken');
    let oUserData: any = await AsyncLocalStorage.getItem('hotel-userData');
    let oCurrentStore: any = await AsyncLocalStorage.getItem('hotel-currentStore');

    console.log(sToken, sRefreshToken, oUserData, oCurrentStore);

    setToken(sToken);
    setRefreshToken(sRefreshToken);
    setUserInfo(oUserData);
    setCurrentStore(oCurrentStore || AsyncLocalStorage.getItem('currentStore'));

    if (sToken && sRefreshToken && oUserData) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }

    // webView 로그인 데이터 전송
    if (isInAppWebView()) {
      window.ReactNativeWebView?.postMessage(getActionData('send_auth', { auth: oUserData }));
    }
  };

  React.useImperativeHandle(oRef, () => ({
    _refLogout() {
      console.log('logout!!!!!!');
      handleLogout();
    },
  }));

  React.useEffect(() => {
    init();
  }, []);

  const receiveData = async (event: any) => {
    const receivedData = event.data;
    if (
      receivedData &&
      receivedData.type &&
      typeof receivedData.type === 'string' &&
      !receivedData.type.includes('webpack')
    ) {
      const firebase_token = await AsyncLocalStorage.getItem('hotel-firebaseToken');
      if (firebase_token) {
        await LoginController.logout({
          firebase_token,
        });
        AsyncLocalStorage.removeItem('hotel-firebaseToken');
      }
      console.log('logout');
        setUserInfo(null);
        setToken('');
        setRefreshToken('');

        await AsyncLocalStorage.removeItem('hotel-userToken');
        await AsyncLocalStorage.removeItem('hotel-userRefreshToken');
        await AsyncLocalStorage.removeItem('hotel-userData');
        await AsyncLocalStorage.removeItem('hotel-currentStore');

        console.log('receivedData', receivedData);

        await AsyncLocalStorage.setItem('url', receivedData.type);
        await AsyncLocalStorage.setItem('hotel-userToken', receivedData.data.token);
        await AsyncLocalStorage.setItem('hotel-userRefreshToken', receivedData.data.refresh_token);
        await AsyncLocalStorage.setItem('hotel-userData', JSON.stringify(receivedData.data));

        setToken(receivedData.data.token);
        setRefreshToken(receivedData.data.refresh_token);
        setUserInfo(receivedData.data);
        setIsLoggedIn(true);

      const currentStore: StoreType = receivedData.data.store_list.find(
        (item: StoreType) => item.store_type === 4,
      );
      if (currentStore) {
        setCurrentStore({
          key: 0,
          value: currentStore.store_id,
          name: currentStore.store_name,
          label: currentStore.store_name,
        });
        await AsyncLocalStorage.setItem(
          'hotel-currentStore',
          JSON.stringify({
            key: 0,
            value: currentStore.store_id,
            name: currentStore.store_name,
            label: currentStore.store_name,
          }),
        );
      }
    }
  };

  const handlePosLogout = async () => {
    const url = await AsyncLocalStorage.getItem('url');
    if (url && url !== 'admin') {
      setTimeout(() => {
        handleLogout();

        AsyncLocalStorage.removeItem('url');
      }, 100);
    }
  };
  const unmountCheck = async () => {
    const url = await AsyncLocalStorage.getItem('url');

    console.log('url', url, typeof url, url.length);

    if (url && url !== 'admin') {
      AsyncLocalStorage.removeItem('hotel-userRefreshToken');
      AsyncLocalStorage.removeItem('hotel-userData');
      AsyncLocalStorage.removeItem('hotel-currentStore');

      console.log('orderlink logout');
    }
  };

  React.useEffect(() => {
    window.addEventListener('message', receiveData);
    // window.addEventListener('beforeunload', handlePosLogout);

    return () => {
      window.removeEventListener('message', receiveData);
      // window.removeEventListener('beforeunload', handlePosLogout);

      unmountCheck();
    };
  }, []);

  if (isLoggedIn === '') {
    return <></>;
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
});
